import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  active: boolean;
  onClick: () => void;
};

const ResetFiltersButton = ({ active, onClick }: Props) => (
  <button
    type="button"
    className="reset-filters"
    disabled={!active}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={faTimes} fixedWidth />
    Reset filters
  </button>
);

export default ResetFiltersButton;
